<template>
    <div class="p-3">
        <b-card
            title="Tambah Pengguna"
        >
            <b-card-text>
                <form class="mt-5">
                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-nama">Nama</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.name" class="form-control" id="input-nama">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-useername">Username</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.username" class="form-control" id="input-useername">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-email">Email</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.email" class="form-control" id="input-email">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-password">Password</label>
                        <div class="col-lg-6">
                            <input type="password" v-model="form.password" class="form-control" id="input-password">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <label class="col-lg-3 text-lg-end pt-2" for="input-akses-level">Akses Level</label>
                        <div class="col-lg-6">
                            <input type="text" v-model="form.akses_level" class="form-control" id="input-akses-level">
                        </div>
                    </div>

                    <div class="form-group row pb-4">
                        <div class="col-lg-3 text-lg-end pt-2"></div>
                        <div class="col-lg-6">
                            <b-button class="btn-sm" variant="primary" @click="saveUser">Simpan</b-button>
                            <b-button class="btn-sm" @click="cancelAdd">Batal</b-button>
                        </div>
                    </div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            user: null,
            form: {
                name: null,
                username: null,
                email: null,
                password: null,
                akses_level: null,
            }
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')
        },
        saveUser() {
            let uri = '/api/users'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.post(uri, this.form, headers).then(response => {
                if (response.data.status == 'success') {
                    alert('Data berhasil disimpan!')
                    this.$router.push({ name: 'konfigurasi_user' }).catch(()=>{})
                } else {
                    alert(response.data.message)
                }
            }).catch((error) => {
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        cancelAdd() {
            this.$router.push('konfigurasi-user')
        }
    }
}
</script>
